import { render, staticRenderFns } from "./ReportScoreGroupRank.vue?vue&type=template&id=01a9603b"
import script from "./ReportScoreGroupRank.vue?vue&type=script&lang=js"
export * from "./ReportScoreGroupRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports